import createIcon from '../../createIcon';

/**
 * @component @name PriorityHigh
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMjFDMTMuMTA0NiAyMSAxNCAyMC4xMDQ2IDE0IDE5QzE0IDE3Ljg5NTQgMTMuMTA0NiAxNyAxMiAxN0MxMC44OTU0IDE3IDEwIDE3Ljg5NTQgMTAgMTlDMTAgMjAuMTA0NiAxMC44OTU0IDIxIDEyIDIxWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEwIDNIMTRWMTVIMTBWM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PriorityHigh = createIcon('PriorityHigh', [
  [
    'path',
    {
      d: 'M12 21C13.1046 21 14 20.1046 14 19C14 17.8954 13.1046 17 12 17C10.8954 17 10 17.8954 10 19C10 20.1046 10.8954 21 12 21Z',
      key: '1f84un',
    },
  ],
  ['path', { d: 'M10 3H14V15H10V3Z', key: '1d6nhu' }],
]);

export default PriorityHigh;
